/** Legacy published calls may explicitly store null instead of an interaction status. */
export function isCallUnread(status: string | null | undefined): boolean {
	return status == null || status === "new" || status === "unread";
}
